module.exports = __webpack_public_path__ + "static/img/mo_btn2.4804b16.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/mo_btn2.png
// module id = YfS0
// module chunks = 7